import React, { useRef, useCallback, useMemo } from 'react';
import TreeView from 'devextreme-react/tree-view';
import * as events from 'devextreme/events';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Transformer from '../../utils/Transformer';
function SideNavigationMenu({
    openMenu,
    pages,
    currentLanguage
}) {
    const treeViewRef = useRef();
    const wrapperRef = useRef();
    const history = useHistory();

    const getWrapperRef = useCallback(
        (element) => {
            const prevElement = wrapperRef.current;
            if (prevElement) {
                events.off(prevElement, 'dxclick');
            }

            wrapperRef.current = element;
            events.on(element, 'dxclick', (e) => {
                openMenu(e);
            });
        },
        [openMenu]
    );

    const renderSidebarItem = (pages, parentId) => {
        const sidebarItems = [];

        const childrenPages = _.filter(pages, (page) => {
            return page.parentId === parentId;
        });

        if (childrenPages) {
            childrenPages.forEach((page) => {
                page.items = renderSidebarItem(pages, page.id);
                sidebarItems.push({
                    ...page,
                    text: Transformer.IsJsonString(page.name) ? JSON.parse(page.name)[currentLanguage] : page.name,
                    icon: page.icon,
                    url: page.url
                });
            });
        }

        return sidebarItems;
    };

    const menu = renderSidebarItem(pages, null);

    const items = useMemo(() => menu.map((item) => ({
        text: Transformer.IsJsonString(item.name) ? JSON.parse(item.name)[currentLanguage] : item.name,
        icon: item.icon,
        items: item.items,
        url: item.url
    })), [currentLanguage, pages]);

    const onItemExpanded = (e) => {
        if (e.node.parent) {
            const nodes = e.node.parent.children.filter(x => x.key !== e.node.key);
            nodes.forEach(function (item) {
                e.component.collapseItem(item.key);
            });
        } else {
            const nodes = treeViewRef.current.instance.getNodes().filter(x => x.key !== e.node.key);
            nodes.forEach(function (item) {
                e.component.collapseItem(item.key);
            });
        }

        treeViewRef.current.instance.selectItem(e.node.key);

        if (e.itemData.url !== '') { history.push(e.itemData.url); }
    };

    return (
        <div
            className={'dx-theme-accent-as-background-color side-navigation-menu'}
            ref={getWrapperRef}
        >
            <TreeView
                ref={treeViewRef}
                items={items}
                onItemClick={onItemExpanded}
                selectionMode={'single'}
                expandEvent={'click'}
                width={'250px'}
            />
        </div>
    );
}
SideNavigationMenu.propTypes = {
    currentLanguage: PropTypes.string.isRequired,
    pages: PropTypes.array,
    openMenu: PropTypes.any
};
export default SideNavigationMenu;
